import React from 'react';
import loadable from '@loadable/component';
import { Props } from './view';

const ListLoadable = loadable(() =>
  import(/* webpackChunkName: "sidebar-views" */ './view')
);

const List = (props: Props) => <ListLoadable {...props} />;

export default List;
